import React, { Fragment } from 'react'
import { connect } from 'react-redux'
import { SideNav, SideNavHeader, SideNavActions, SideNavAction } from 'common/layouts/SideNavLayout/SideNav'
import { DELETE_EXPERIENCE_DIALOG } from '../../dialogs/DeleteExperienceDialog'
import { COPY_EXPERIENCE_DIALOG } from '../../dialogs/CopyExperienceDialog'
import { experienceSelectors } from 'data/resources/experiences'

export class _ExperiencesSideNav extends React.PureComponent {
  render () {
    const { experience, allowMessaging, isPublished, showDialog, collapseState } = this.props

    if (!experience) {
      return null
    }

    const links = [
      { title: 'Overview', to: `/experiences/${experience.id}/edit`, icon: 'md-home' },
      { title: 'Details', to: `/experiences/${experience.id}/details`, icon: 'md-calendar' },
      { title: 'Routes', to: `/experiences/${experience.id}/routes`, icon: 'md-pin' },
      { title: 'Guide', to: `/experiences/${experience.id}/guide`, icon: 'md-map' },
      isPublished && { title: 'Share', to: `/experiences/${experience.id}/shortcut`, icon: 'qrcode-scan' },
      allowMessaging && { title: 'Messages', to: `/experiences/${experience.id}/messages`, icon: 'md-chatbubbles' },
      { title: 'Guests', to: `/experiences/${experience.id}/guests`, icon: 'md-bicycle' }
    ].filter(x => x)

    return (
      <SideNav links={links}>
        {!collapseState && <SideNavHeader>
          <h2 style={{ margin: '0 0' }}>Create Experience</h2>
        </SideNavHeader>}

        <SideNavActions>
          {!collapseState && <Fragment>
            <SideNavAction
              onClick={() => showDialog(COPY_EXPERIENCE_DIALOG)}
              i='md-copy'
              label='Copy' />
            <SideNavAction
              onClick={() => showDialog(DELETE_EXPERIENCE_DIALOG)}
              i='md-trash'
              label='Delete' />
          </Fragment>}
          {collapseState !== 'user' && <SideNavAction
            href={`/experiences/${experience.id}/back_to_account`}
            i='ios-arrow-back'
            label='Back to Account' />}
        </SideNavActions>
      </SideNav>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const experience = experienceSelectors.find(state, ownProps.experienceId)
  const lastPackage = experienceSelectors.lastPackage(state, ownProps.experienceId)
  return {
    experience,
    allowMessaging: experienceSelectors.allowMessaging(state, ownProps.experienceId),
    isPublished: lastPackage && lastPackage.packageFileSize && experience?.active
  }
}

export const ExperiencesSideNav = connect(
  mapStateToProps,
  null
)(_ExperiencesSideNav)
